"use client";

import { m, AnimatePresence } from "framer-motion";
import Link from "next/link";
import { useEffect, useState } from "react";

const ForestLink = () => {
  // Hide the floating button while the hero is in view — its fixed
  // bottom-left position can overlap the hero's centered MDG LABS
  // wordmark at certain viewport heights and during scroll. We show
  // it once the user has scrolled half a viewport past the hero so
  // it's available throughout the rest of the page without ever
  // sitting on top of the brand wordmark.
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.5);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
    <m.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.4 }}
      className="fixed bottom-6 left-6 z-[9999]"
    >
      <Link
        href="/forest"
        className="group relative flex h-14 w-14 items-center justify-center rounded-full border border-emerald-500/40 bg-emerald-950/80 shadow-lg shadow-emerald-500/10 backdrop-blur-md transition-all hover:border-emerald-400/60 hover:bg-emerald-900/80 hover:shadow-[0_0_25px_rgba(16,185,129,0.25)]"
        aria-label="Enter the Forest Walk experience"
      >
        {/* Tree icon */}
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className="text-emerald-400 transition-colors group-hover:text-emerald-300"
        >
          <path
            d="M12 2L7 9h2.5L6 15h3l-2 5h10l-2-5h3l-3.5-6H17L12 2z"
            fill="currentColor"
          />
          <rect x="11" y="20" width="2" height="2" rx="0.5" fill="currentColor" opacity="0.7" />
        </svg>

        {/* Tooltip — workshop voice replaces the generic "Forest Walk"
            with the artisan framing. This corner button is the
            always-on invitation to the workshop's after-hours space. */}
        <span className="pointer-events-none absolute bottom-full left-1/2 mb-3 -translate-x-1/2 whitespace-nowrap rounded-lg border border-emerald-500/20 bg-emerald-950/90 px-3 py-1.5 text-xs font-medium text-emerald-300 opacity-0 backdrop-blur-md transition-opacity group-hover:opacity-100">
          the workshop
        </span>

        {/* Glow pulse ring */}
        <span className="absolute inset-0 animate-ping rounded-full border-2 border-emerald-500/20" style={{ animationDuration: "3s" }} />
      </Link>
    </m.div>
      )}
    </AnimatePresence>
  );
};

export default ForestLink;
